import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { useEffect, useState } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import DossiersDataTable from '../../../dossiers/DossiersDataTable';

function ArchiveSection({ display, title, thirdpartyArchives }) {
  const { classes } = useStyles();
  const [tpVisibleArchiveDossCount, setTpVisibleArchiveDossCount] = useState(null);
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(thirdpartyArchives?.length);
  }, [thirdpartyArchives]);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"archives"}>
      <EAAccordion
        title={title}
        logo="archive"
        counter={
          tpVisibleArchiveDossCount !== null
            ? tpVisibleArchiveDossCount
            : thirdpartyArchives?.length
        }
        totalCount={thirdpartyArchives?.length}
        opened={isExpanded}
      >
        {thirdpartyArchives && (
          <DossiersDataTable
            monitored={false}
            dossiers={thirdpartyArchives}
            component="thirdparty"
            pageSize={10}
            multiDataGridPage
            sheetVariant={true}
            onVisibleRowsCountChange={(count) =>
              setTpVisibleArchiveDossCount(count)
            }
          />
        )}
      </EAAccordion>
    </Grid>
  );
}

export default ArchiveSection;
